// extracted by mini-css-extract-plugin
export var chip = "_mn-2";
export var chipBody = "_mn-8";
export var chipHeader = "_mn-9";
export var chipWithKind = "_mn-7";
export var icon = "_mn-3";
export var kind = "_mn-a";
export var remove = "_mn-5";
export var removeIcon = "_mn-6";
export var row = "_mn-0";
export var rowHistorical = "_mn-1";
export var text = "_mn-4";